import { atom } from "jotai";

const INITIAL_INDEX: number = 0;

export const scoringSelectedPeriodAtom = atom(INITIAL_INDEX);
